export class invoiceData {
    id:number;
    invoiceNumber: string;
    invoiceDate: string;
    serviceDate: string;
    invoiceAmount: number;
    typeofService: string;
    clientId: number;
    createdDate: string;
    createdBy: string;
}
